import * as permissions from '@/config/static_permissions'
import store from '@/store'

// An agnostic class that help determine
// if an operation is permitted or not
class Permission {

  // will load the static_permissions content
  static loadPermissions() {
    let user = store.state.current_user

    if (!user) return {}

    let perms = permissions[user.role + "_permission"]
    if (user.role == 'admin') {
      // If the user is an admin, then also merge in all user permissions
      let userPerms = permissions["user_permission"]
      _.merge(userPerms, perms)
      return userPerms
    }
    return perms
  }

  // @param operations (object) is the permission object returned by auth action
  static readPermissions(operations) {
    let newOperations = {}

    Object.keys(operations).map(function(modelName, index) {
      if (typeof operations[modelName] === "object") {
        Object.keys(operations[modelName]).map(function(operationName, index) {
          let keyname = modelName + '.' + operationName
          newOperations[keyname] = operations[modelName][operationName]
        })
      } else {
        newOperations[modelName] = operations[modelName]
      }
    })

    return newOperations
  }

  static getRole() {
    let user = store.state.current_user
    if (!user) return null
    return user.role
  }

  static isRoot() {
    return Permission.getRole() === 'root'
  }

  // @param permissions (object) return of the readPermissions method
  // @param operation (string) the operation name
  // @return (boolean) true if allowed, false if not
  static can(permissions, operation) {

    if (permissions == null) {
      permissions = Permission.loadPermissions()
    } else if (arguments.length == 1 && typeof permissions == 'string') {
      // Also support a single argument, which is just "operation"
      operation = _.cloneDeep(permissions)
      permissions = Permission.loadPermissions()
    }

    if (permissions.role == "root") {
      return true
    }

    let perm = Permission.readPermissions(permissions)
    if (perm[operation]) {
      return perm[operation]
    } else {
      return false
    }
  }

  static planCan(operation) {
    let plan = store.getters.getCurrentOrganizationPlan
    if (plan) {
      let permissions = plan.rules
      if (permissions[operation]) {
        return permissions[operation]
      }
    }
    return false
  }

}


export default Permission



// WEBPACK FOOTER //
// ./src/classes/Permission.js